import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { SoHuu } from "./SoHuu";

export const BtnSoHuu = ({ TaiSanID }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Sở hữu"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
              <img src="/app-assets/images/icon-so-huu-v2.png" />
        </PopoversBootrap>
      </a>
      {show && <SoHuu show={show} onHide={handleClose} taiSanId={TaiSanID} />}
    </>
  );
};
